import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshrivardhancab() {



  const cardData = {




keyword: "Pune to Shrivardhan Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Shrivardhan Cab Service for families, couples, friends, senior citizens, and groups planning a relaxing coastal journey. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for one-way trips, round trips, weekend getaways, sightseeing, and customized travel plans. With experienced drivers, clean and well-maintained cars, flexible pickup locations across Pune, spacious luggage facilities, transparent pricing, and 24/7 customer assistance, we make the journey to Shrivardhan convenient and comfortable. Travelers can also combine Shrivardhan with nearby beaches, temples, coastal attractions, and destinations around Raigad for a complete holiday itinerary.",

topPlaces: [
  {
    title: "Shrivardhan Beach",
    description: "Shrivardhan Beach is a peaceful coastal destination known for its sandy shoreline, Arabian Sea views, palm trees, and relaxing atmosphere. It is ideal for families, couples, and groups looking for a quieter beach getaway from Pune. Garud Cab Service provides private chauffeur-driven cabs for comfortable one-way journeys, return trips, and flexible local sightseeing."
  },
  {
    title: "Harihareshwar",
    description: "Harihareshwar is a popular coastal and pilgrimage destination near Shrivardhan, known for the ancient Harihareshwar Temple and beautiful sea-facing surroundings. Travelers from Pune can conveniently combine Shrivardhan and Harihareshwar in the same trip. A private cab provides flexible transportation for families and groups visiting both destinations."
  },
  {
    title: "Diveagar",
    description: "Diveagar is a scenic Konkan destination famous for its peaceful beach, coconut groves, coastal villages, and relaxed holiday atmosphere. It is well suited for travelers planning a weekend escape from Pune. Garud Cab Service offers comfortable vehicles for families and groups who want to explore Diveagar along with Shrivardhan and nearby coastal attractions."
  },
  {
    title: "Kondivali Beach",
    description: "Kondivali Beach is a quieter coastal attraction in the Shrivardhan region, offering beautiful sea views and a peaceful environment away from crowded tourist areas. It is suitable for visitors who prefer a relaxed beach experience. Travelers can include the beach in a customized sightseeing itinerary while traveling by private cab from Pune."
  },
  {
    title: "Somaji Temple",
    description: "Somaji Temple is a local religious attraction in the Shrivardhan region and provides visitors with an opportunity to experience the area's spiritual and cultural heritage. Devotees and families can include the temple during their coastal journey. A chauffeur-driven cab makes it convenient to visit religious sites along with nearby beaches."
  },
  {
    title: "Velas",
    description: "Velas is a scenic coastal village in the Konkan region known for its beach, traditional village surroundings, and seasonal turtle conservation activities. It is an interesting destination for nature lovers and travelers seeking a quieter coastal experience. Visitors from Pune can plan a private cab journey covering Velas and other nearby Konkan attractions."
  },
  {
    title: "Bankot Fort",
    description: "Bankot Fort is a historic coastal fort located near the Harihareshwar and Shrivardhan region, offering views of the surrounding coastline and Savitri River area. The fort is suitable for travelers interested in history, photography, and scenic landscapes. Garud Cab Service can include Bankot in a customized coastal sightseeing route from Pune."
  },
  {
    title: "Madhavbagh",
    description: "Madhavbagh is a spiritual and cultural attraction associated with the Konkan region and provides visitors with a peaceful setting during their journey. Travelers exploring Shrivardhan and nearby destinations can include it as part of their itinerary. A private cab offers convenient transportation between multiple sightseeing points."
  },
  {
    title: "Phansad Wildlife Sanctuary",
    description: "Phansad Wildlife Sanctuary is a natural destination in the Raigad region known for forests, wildlife, birdlife, and biodiversity. It is a suitable option for travelers who want to combine a coastal holiday with nature exploration. Families and groups from Pune can plan a comfortable road journey with a spacious chauffeur-driven cab."
  },
  {
    title: "Murud",
    description: "Murud is a popular Konkan destination known for its coastline, beaches, coastal scenery, and access to the historic Murud-Janjira region. It can be included in an extended coastal road trip from Pune covering Shrivardhan, Harihareshwar, and nearby attractions. Garud Cab Service provides flexible one-way and round-trip cab options for such multi-destination journeys."
  }
],



"services": [
{
"name": "Pune to Shrivardhan Cab Booking",
"description": "Book Pune to Shrivardhan Cab Booking for a comfortable and convenient journey to the Konkan coast with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium cab options for family trips, beach holidays, sightseeing, weekend travel, and one-way or round-trip journeys."
},
{
"name": "Pune to Shrivardhan Innova Crysta",
"description": "Hire a Pune to Shrivardhan Innova Crysta for a premium and spacious journey with comfortable seating, ample luggage space, AC interiors, and an experienced chauffeur. Innova Crysta is suitable for families, groups, senior passengers, corporate travelers, and tourists planning a relaxed outstation trip to Shrivardhan and nearby Konkan destinations."
},
{
"name": "Pune to Shrivardhan Ertiga Car Booking",
"description": "Book Pune to Shrivardhan Ertiga Car Booking for a practical and comfortable family journey with spacious seating, useful luggage capacity, air conditioning, and professional chauffeur service. Ertiga is a convenient choice for small groups, family vacations, beach trips, sightseeing, and planned one-way or round-trip travel from Pune."
},
{
"name": "Pune to Shrivardhan Beach Cab",
"description": "Reserve a Pune to Shrivardhan Beach Cab for a comfortable road trip to the beautiful Konkan coastline. Enjoy private AC transportation, experienced chauffeurs, convenient pickup from Pune, and vehicle choices such as Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV for families, couples, groups, and tourists planning a beach vacation."
},
{
"name": "Pune to Shrivardhan Beach Cab Fare",
"description": "Check Pune to Shrivardhan Beach Cab Fare according to your selected vehicle, passenger count, luggage requirements, and journey type. Choose economical Sedan or Swift Dzire cars or spacious Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options for comfortable beach travel, sightseeing, weekend trips, and one-way or return journeys."
},
{
"name": "Pune to Shrivardhan Beach Innova Crysta",
"description": "Book Pune to Shrivardhan Beach Innova Crysta for a premium family and group journey with spacious interiors, comfortable seating, air conditioning, and generous luggage capacity. The chauffeur-driven Crysta is suitable for beach vacations, weekend getaways, sightseeing, family outings, and longer Konkan travel requiring additional comfort."
},
{
"name": "Pune to Shrivardhan Beach Innova Cabs",
"description": "Choose Pune to Shrivardhan Beach Innova Cabs for dependable and comfortable transportation to the Konkan coast. Spacious Innova vehicles with professional chauffeurs provide convenient pickup, AC travel, ample luggage space, and private door-to-door service for families, groups, tourists, and travelers planning beach trips or sightseeing."
},
{
"name": "Pune to Shrivardhan Beach Ertiga Cabs",
"description": "Hire Pune to Shrivardhan Beach Ertiga Cabs for comfortable and affordable group transportation with spacious seating, AC interiors, practical luggage capacity, and professional drivers. Ertiga is suitable for families, friends, weekend travelers, beach visitors, and tourists looking for convenient private transportation from Pune to Shrivardhan."
},
{
"name": "Pune to Shrivardhan Beach Package",
"description": "Book a Pune to Shrivardhan Beach Package for a convenient coastal getaway with comfortable chauffeur-driven transportation and flexible travel arrangements. The journey can be planned for families, couples, friends, and groups visiting Shrivardhan Beach, nearby attractions, temples, and other Konkan destinations with suitable vehicle options."
},
{
"name": "Pune to Shrivardhan Beach Tour Package",
"description": "Choose a Pune to Shrivardhan Beach Tour Package for a relaxing Konkan road trip with private cab transportation, experienced chauffeurs, comfortable AC vehicles, and flexible sightseeing plans. Select Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to your group size, luggage, itinerary, and comfort requirements."
},
{
"name": "Pune to Harihareshwar Cab",
"description": "Reserve Pune to Harihareshwar Cab for a comfortable and private journey from Pune to the popular Konkan coastal destination. Enjoy professional chauffeur service, clean AC vehicles, spacious seating, and convenient pickup arrangements for family trips, temple visits, beach holidays, sightseeing, weekend travel, and outstation journeys."
},
{
"name": "Pune to Harihareshwar Cab Booking",
"description": "Book Pune to Harihareshwar Cab Booking for a scheduled and hassle-free journey with direct pickup and drop facilities. Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV vehicles according to passenger count, luggage requirements, and travel plans for family, religious, or leisure trips."
},
{
"name": "Pune to Harihareshwar Innova Crysta",
"description": "Hire Pune to Harihareshwar Innova Crysta for a premium and spacious outstation journey with comfortable seating, AC interiors, ample luggage space, and an experienced chauffeur. It is a suitable option for families, groups, senior travelers, and tourists planning a relaxed visit to Harihareshwar Beach, temple, and nearby Konkan attractions."
},
{
"name": "Pune to Ganpatipule Cabs",
"description": "Book Pune to Ganpatipule Cabs for comfortable private transportation from Pune to the scenic Konkan destination of Ganpatipule. Choose from Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options with professional chauffeurs for family vacations, temple visits, beach trips, sightseeing, weekend getaways, and round-trip journeys."
},
{
"name": "Pune to Konkan Innova Cab",
"description": "Reserve a Pune to Konkan Innova Cab for comfortable long-distance travel across popular Konkan destinations. Spacious Innova vehicles offer AC interiors, generous luggage space, and professional chauffeur service for families and groups visiting Shrivardhan, Harihareshwar, Ganpatipule, Ratnagiri, Sawantwadi, and other coastal locations."
},
{
"name": "Pune to Mahabaleshwar Innova Rate",
"description": "Check Pune to Mahabaleshwar Innova Rate for a comfortable and spacious chauffeur-driven journey from Pune to the hill station. Innova is suitable for families and groups requiring additional seating and luggage space, with convenient pickup, AC travel, and flexible one-way or round-trip arrangements for sightseeing and weekend trips."
},
{
"name": "Pune to Konkan Darshan Cab",
"description": "Book Pune to Konkan Darshan Cab for a convenient sightseeing journey covering popular coastal destinations, beaches, temples, and scenic locations across the Konkan region. Travel in comfortable AC vehicles with experienced chauffeurs and select Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV options according to your itinerary."
},
{
"name": "Pune to Sawantwadi Cab",
"description": "Choose Pune to Sawantwadi Cab for dependable outstation transportation to the southern Konkan region with professional chauffeurs and comfortable AC vehicles. The service is suitable for family travel, sightseeing, business visits, holiday trips, and longer coastal journeys with Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options."
},
{
"name": "Pune to Ratnagiri Cab Price",
"description": "Get Pune to Ratnagiri Cab Price information according to your preferred vehicle and travel requirements. Choose economical Sedan and Swift Dzire options or spacious Ertiga, Innova, Innova Crysta, Kia Carens, and SUV cabs for comfortable journeys to Ratnagiri with professional chauffeur service, convenient pickup, luggage space, and one-way or round-trip travel options."
}
],
"tableData": [
["Pune to Shrivardhan Cab Booking", "Pune to Shrivardhan Innova Crysta"],
["Pune to Shrivardhan Ertiga Car Booking", "Pune to Shrivardhan Beach Cab"],
["Pune to Shrivardhan Beach Cab Fare", "Pune to Shrivardhan Beach Innova Crysta"],
["Pune to Shrivardhan Beach Innova Cabs", "Pune to Shrivardhan Beach Ertiga Cabs"],
["Pune to Shrivardhan Beach Package", "Pune to Shrivardhan Beach Tour Package"],
["Pune to Harihareshwar Cab", "Pune to Harihareshwar Cab Booking"],
["Pune to Harihareshwar Innova Crysta", "Pune to Ganpatipule Cabs"],
["Pune to Konkan Innova Cab", "Pune to Mahabaleshwar Innova Rate"],
["Pune to Konkan Darshan Cab", "Pune to Sawantwadi Cab"],
["Pune to Ratnagiri Cab Price", ""]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Shrivardhan Cab for a Relaxing Coastal Journey",
    WhyChoosedescription: "Garud Cab Service provides private Pune to Shrivardhan cab services for beach holidays, family vacations, weekend escapes, couple trips, and travellers looking for a convenient road journey to the Konkan coast."
  },
  {
    WhyChooseheading: "Travel Directly from Pune to Shrivardhan",
    WhyChoosedescription: "Enjoy a dedicated cab journey from your preferred pickup point in Pune to Shrivardhan without the hassle of changing vehicles, making the trip more convenient for families and travellers carrying luggage."
  },
  {
    WhyChooseheading: "Perfect for Konkan Weekend Getaways",
    WhyChoosedescription: "Shrivardhan is a popular choice for a peaceful coastal break, and a private cab allows you to plan your departure according to your holiday schedule and spend more time enjoying the destination."
  },
  {
    WhyChooseheading: "One-Way & Return Travel Options",
    WhyChoosedescription: "Choose a one-way cab if you are staying in Shrivardhan, or arrange a round-trip journey when your travel plan includes returning to Pune after your beach holiday or sightseeing."
  },
  {
    WhyChooseheading: "Comfortable for Families and Small Groups",
    WhyChoosedescription: "Garud Cab Service can arrange a suitable vehicle according to passenger count, luggage, and comfort requirements, making the journey practical for families, couples, friends, and small groups."
  },
  {
    WhyChooseheading: "Explore Shrivardhan & Nearby Beaches",
    WhyChoosedescription: "Make your coastal trip more enjoyable by planning visits to Shrivardhan Beach, Harihareshwar, Diveagar, local temples, viewpoints, and other nearby attractions according to your itinerary."
  },
  {
    WhyChooseheading: "Useful for Resorts, Homestays & Family Holidays",
    WhyChoosedescription: "Book a private cab when travelling from Pune to a Shrivardhan resort, hotel, homestay, beach accommodation, family gathering, or weekend holiday destination."
  },
  {
    WhyChooseheading: "Plan Your Shrivardhan Trip with Garud",
    WhyChoosedescription: "Provide your Pune pickup location, Shrivardhan destination, travel date, passenger details, luggage requirement, and one-way or return preference to arrange a suitable cab with Garud Cab Service."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Shrivardhan Cab Service?",
    answer: "Yes, Garud Cab Service provides Pune to Shrivardhan cabs for beach holidays, family trips, weekend getaways, resort transfers, sightseeing, and personal travel."
  },
  {
    question: "Can I book a one-way cab from Pune to Shrivardhan?",
    answer: "Yes, one-way cab service is available for passengers who need direct transportation from Pune to Shrivardhan."
  },
  {
    question: "Can I book a return cab from Shrivardhan to Pune?",
    answer: "Yes, return and round-trip cab arrangements can be planned according to your holiday dates and preferred departure schedule."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, or another preferred location in Pune."
  },
  {
    question: "Is Pune to Shrivardhan cab suitable for a family trip?",
    answer: "Yes, families can choose a suitable private vehicle based on passenger count, luggage, and comfort requirements for the coastal journey."
  },
  {
    question: "Can I include Harihareshwar and Diveagar in the trip?",
    answer: "Yes, nearby destinations such as Harihareshwar and Diveagar can be included in your itinerary depending on your available travel time and trip plan."
  },
  {
    question: "Can I book a cab to a Shrivardhan resort or hotel?",
    answer: "Yes, direct transportation can be arranged from Pune to your selected resort, hotel, homestay, or other accommodation in Shrivardhan."
  },
  {
    question: "Can I hire a cab for Shrivardhan sightseeing?",
    answer: "Yes, sightseeing and local travel can be included in the itinerary according to your preferred places and available travel schedule."
  },
  {
    question: "Which vehicle is suitable for a group travelling to Shrivardhan?",
    answer: "Vehicle selection depends on the number of passengers, luggage, and comfort preferences. Garud Cab Service can arrange a suitable option for your group."
  },
  {
    question: "How can I book a Pune to Shrivardhan Cab?",
    answer: "Share your Pune pickup point, Shrivardhan destination, travel date, passenger count, preferred vehicle, and one-way or return requirement with Garud Cab Service to arrange your booking."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Pranav Kulkarni",
    feedback: "We planned a weekend trip from Pune to Shrivardhan with our family and booked a private cab. The direct pickup and comfortable journey made the coastal holiday much easier.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Desai",
    feedback: "Our group travelled to Shrivardhan and also planned visits around the nearby coastal area. The private cab gave us useful flexibility throughout the trip.",
    rating: 5
  }
];






  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shrivardhan Cab",
  "image": "https://garudcabs.com/assets/images/pune-to-shrivardhan-cab.webp",
  "description": "Book Pune to Shrivardhan Cab with Garud Cab for safe, comfortable, and convenient coastal travel. Get reliable one way and round trip cab services from Pune to Shrivardhan and Shrivardhan Beach, with Innova Crysta and Ertiga options suitable for family vacations, weekend getaways, sightseeing, and beach trips.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-shrivardhan-cab"
  }
};





  return (
    <div>

<Helmet>
  <title>Pune to Shrivardhan Cab | Beach Taxi & Cab Booking | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Shrivardhan Cab with Garud Cab for comfortable and reliable coastal travel. Get cab booking, Innova Crysta, Ertiga, and Shrivardhan Beach taxi services with one way and round trip options."
  />

  <meta
    name="keywords"
    content="Pune to Shrivardhan cab booking, Pune to Shrivardhan Innova Crysta, Pune to Shrivardhan Ertiga car booking, Pune to Shrivardhan Beach cab, Pune to Shrivardhan Beach cab fare, Pune to Shrivardhan Beach Innova Crysta"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/28.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshrivardhancab;